export const MAX_CONCURRENT_UPLOADS = 5;
export const MIN_DOWNLOAD_PERCENTAGE = 10;
